import React from 'react';
import { useTranslation } from 'react-i18next';

import { translateStatus, OrderWithFormats } from './common';
import './OrderHeader.scss';

interface OrderHeaderProps {
  sortedOrders: OrderWithFormats[];
}

const OrderHeader: React.FC<OrderHeaderProps> = ({ sortedOrders }) => {
  const { t } = useTranslation();

  const getTsv = () => {
    const tsvOrders = sortedOrders.map((order) => {
      const summary = order.sampleSummary;
      const total = summary.uploaded + summary.processing + summary.finished;
      return [
        translateStatus(t, order.status),
        order.orderNumber,
        order.description,
        total,
        summary.uploaded,
        summary.processing,
        summary.finished,
        order.sampleSummary.latestProcessed
          ? order.sampleSummary.latestProcessedFormatted
          : '',
        order.createdFormatted,
      ].join('\t');
    });

    const exportHeadings = [
      t('orders_status', { uppercase: true }),
      t('orders_orderNumber', { uppercase: true }),
      t('orders_orderName', { uppercase: true }),
      t('orders_stagesQuantity', { uppercase: true }),
      t('orders_stagesUploaded', { uppercase: true }),
      t('orders_stagesProcessing', { uppercase: true }),
      t('orders_stagesFinished', { uppercase: true }),
      t('orders_resultsActivity', { uppercase: true }),
      t('orders_created', { uppercase: true }),
    ].join('\t');
    tsvOrders.unshift(exportHeadings);

    const tsvContent = tsvOrders.join('\n');
    const tsv = `data:text/tab-separated-values,${encodeURIComponent(
      tsvContent
    )}`;
    return tsv;
  };

  const downloadObject = (url: string, filename: string) => {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className='order-header mb-2 clearfix main-page-header'>
      <div className='float-left page-header-1'>
        <h1>{t('orders_orders')}</h1>
        <span className='list-count ml-1'>({sortedOrders.length})</span>
      </div>
      {sortedOrders.length > 0 ? (
        <div className='float-right page-header-1 export-right'>
          <div
            className='export-download-link align-middle colors-gray-2'
            onClick={() =>
              downloadObject(
                getTsv(),
                `${t('common_orders').toLocaleLowerCase()}.tsv`
              )
            }
          >
            <i className='fas fa-arrow-alt-circle-down mr-1 fcolor--primary-brand'></i>
            {t('order_exportList')}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default OrderHeader;
